import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {SubscriptionResponse} from "../interface/subscriptionResponse";

@Injectable({
  providedIn: "root"
})
export class SubscriptionPaymentService {

  private readonly endpointUrl = environment.apiUrl + '/subscription';

  constructor(
    private http: HttpClient
  ) {
  }

  public purchase(subscriptionInfoId: number, isMonthly: boolean, promoCode: string | null): Observable<SubscriptionResponse> {
    const body = {
      subscriptionInfoId: subscriptionInfoId,
      isMonthly: isMonthly,
      promoCode: promoCode
    }
    const url: string = `${this.endpointUrl}/purchase`;
    return this.http.post<SubscriptionResponse>(url, body);
  }
}
